/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';
import {Observable} from 'rxjs';

export class PilotTrackerApi extends BaseApi {
  endPoint: string = '/api/admin/reports/pilot-tracker';

  public getTimeseriesDataBySurveyId(id: any): Observable<any> {
    const _routeParams = {
      id: id
    };
    return this._get(this.endPoint + '/time-series/:id?', _routeParams);
  }

  public getList(): Observable<any> {
    return this._get(this.endPoint + '/list', {});
  }
}
